"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoreContainer = exports.setContainer = exports.createContainer = void 0;
require("reflect-metadata");
var inversify_1 = require("inversify");
function createContainer() {
    var container = new inversify_1.Container();
    return container;
}
exports.createContainer = createContainer;
var coreContainer = createContainer();
function setContainer(container) {
    coreContainer = container;
}
exports.setContainer = setContainer;
function getCoreContainer() {
    return coreContainer;
}
exports.getCoreContainer = getCoreContainer;
//# sourceMappingURL=container.js.map